import { useEffect } from "react";
import SiteNav from "./SiteNav";
import SiteFooter from "./SiteFooter";
import CookieBanner from "./CookieBanner";
import "@/site.css";

// Coquille commune aux pages publiques : nav + en-tête + contenu + footer.
export default function PageShell({ eyebrow, title, lead, actions, centered, children }) {
  useEffect(() => { document.title = `${title} — Perform`; window.scrollTo(0, 0); }, [title]);
  return (
    <div className="site">
      <SiteNav />
      <main>
        <div className={`page-head${centered ? " is-centered" : ""}`}>
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          <h1>{title}</h1>
          {lead && <p className="page-lead">{lead}</p>}
          {actions && <div className="page-head-actions">{actions}</div>}
        </div>
        <div className="page-body">{children}</div>
      </main>
      <SiteFooter />
      <CookieBanner />
    </div>
  );
}

export function Section({ title, lead, children, id }) {
  return (
    <section className="page-section" id={id}>
      {title && <h2>{title}</h2>}
      {lead && <p className="section-lead">{lead}</p>}
      {children}
    </section>
  );
}
